<template>
  <b-overlay
    :show="loader.formulario"
    opacity="0.50"
    rounded="sm"
  >
    <!-- Header: Personal Info -->
    <div class="d-flex text-primary">
      <feather-icon
        icon="UserIcon"
        size="19"
      />
      <h4 class="mb-0 ml-50 text-primary">
        Información personal
      </h4>
    </div>

    <!-- Form: Persona-->
    <validation-observer ref="simpleRules">
      <b-form class="mt-1">
        <b-row>

          <!-- Nombre -->
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group
              label="Nombre*"
              label-for="nombre"
            >
              <validation-provider
                #default="{ errors }"
                name="nombre"
                rules="required|alpha_spaces|min:3|max:45"
              >
                <b-form-input
                  id="nombre"
                  v-model="persona.nombre"
                  :state="errors.length > 0 ? false:null"
                  autocomplete="off"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- segundo Nombre -->
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group
              label="Segundo nombre"
              label-for="segundoNombre"
            >
              <validation-provider
                #default="{ errors }"
                name="segundoNombre"
                rules="alpha_spaces|min:3|max:45"
              >
                <b-form-input
                  id="segundoNombre"
                  v-model="persona.segundoNombre"
                  :state="errors.length > 0 ? false:null"
                  autocomplete="off"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- Apellido paterno -->
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group
              label="Apellido paterno*"
              label-for="apellidoPaterno"
            >
              <validation-provider
                #default="{ errors }"
                name="apellidoPaterno"
                rules="required|alpha_spaces|min:2|max:45"
              >
                <b-form-input
                  id="apellidoPaterno"
                  v-model="persona.apellidoPaterno"
                  :state="errors.length > 0 ? false:null"
                  autocomplete="off"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- Apellido materno  -->
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group
              label="Apellido materno"
              label-for="apellidoMaterno"
            >
              <validation-provider
                #default="{ errors }"
                name="apellidoMaterno"
                rules="alpha_spaces|min:2|max:45"
              >
                <b-form-input
                  id="apellidoMaterno"
                  v-model="persona.apellidoMaterno"
                  :state="errors.length > 0 ? false:null"
                  autocomplete="off"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- Fecha de nacimiento -->
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group
              label="Fecha de nacimiento"
              label-for="fechaNacimiento"
            >
              <flat-pickr
                v-model="persona.fechaNacimiento"
                class="form-control"
                :config="{ dateFormat: 'Y-m-d'}"
                placeholder="YYYY-MM-DD"
              />
            </b-form-group>
          </b-col>
          <!-- Genero  -->
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group
              label="Género"
              label-for="gender"
              label-class="mb-1"
            >
              <b-form-radio-group
                id="gender"
                v-model="persona.genero"
                :options="genderOptions"
                value="male"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <div class="d-flex mt-2 text-primary">
          <feather-icon
            icon="ArchiveIcon"
            size="19"
          />
          <h4 class="mb-0 ml-50 text-primary">
            Datos de indentidad
          </h4>
        </div>
        <b-row class="mt-1">
          <!-- CURP -->
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group
              label="CURP*"
              label-for="curp"
            >
              <validation-provider
                #default="{ errors }"
                name="curp"
                rules="required|min:18|max:18"
              >
                <b-form-input
                  id="curp"
                  v-model="persona.curp"
                  :state="errors.length > 0 ? false:null"
                  placeholder="CURP"
                  autocomplete="off"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- RFC -->
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group
              label="RFC"
              label-for="rfc"
            >
              <validation-provider
                #default="{ errors }"
                name="rfc"
                rules="min:13|max:13"
              >
                <b-form-input
                  id="rfc"
                  v-model="persona.rfc"
                  :state="errors.length > 0 ? false:null"
                  placeholder="RFC"
                  autocomplete="off"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- Funcionario activo -->
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group
              label="Funcionario Activo"
              label-for="funcionarioActivo"
              label-class="mb-1"
            >
              <b-form-radio-group
                id="funcionarioActivo"
                v-model="persona.funcionarioActivo"
                :options="funcionarioOptions"
                value="N"
              />
            </b-form-group>
          </b-col>

        </b-row>
        <b-row class="mt-1">
          <!-- Nacionalidad -->
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group
              label="Nacionalidad*"
              label-for="nacionalidad"
            >
              <validation-provider
                #default="{ errors }"
                name="nacionalidad"
                rules="required"
              >
                <b-form-select
                  id="nacionalidad"
                  v-model="persona.nacionalidad"
                  required
                  :options="[{ text: 'MEXICANA', value: 'MEX' }, { text: 'EXTRANJERA', value: 'EXT' }]"
                  value-field="value"
                  text-field="text"
                  :state="persona.nacionalidad === null ? false : true"
                >
                  <template #first>
                    <b-form-select-option
                      :value="null"
                      disabled
                    > -- Selecciona --
                    </b-form-select-option>
                  </template>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-select>
              </validation-provider>
            </b-form-group>
          </b-col>

        </b-row>

        <div class="d-flex mt-2 text-primary">
          <feather-icon
            icon="MessageSquareIcon"
            size="19"
          />
          <h4 class="mb-0 ml-50 text-primary">
            Contacto
          </h4>
        </div>

        <b-row class="mt-1">
          <!-- Telefono  -->
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group
              label="Teléfono personal*"
              label-for="teléfono personal"
            >
              <validation-provider
                #default="{ errors }"
                name="teléfono personal"
                rules="required|min:10|max:10"
              >
                <b-form-input
                  id="telefono1"
                  v-model="persona.telefono1"
                  :state="errors.length > 0 ? false:null"
                  autocomplete="off"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- Telefono 2 -->
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group
              label="Teléfono de trabajo"
              label-for="telefono2"
            >
              <validation-provider
                #default="{ errors }"
                name="teléfono de trabajo"
                rules="min:10|max:10"
              >
                <b-form-input
                  id="telefono2"
                  v-model="persona.telefono2"
                  :state="errors.length > 0 ? false:null"
                  autocomplete="off"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- Ext  -->
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group
              label="Extensión"
              label-for="extension"
            >
              <validation-provider
                #default="{ errors }"
                name="extension"
                rules="max:10"
              >
                <b-form-input
                  id="extension"
                  v-model="persona.extension"
                  :state="errors.length > 0 ? false:null"
                  autocomplete="off"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mt-1">
          <!-- correo  -->
          <b-col
            cols="12"
            md="6"
            lg="4"
          >

            <b-form-group
              label="Correo electrónico personal (principal) *"
              label-for="email"
            >
              <validation-provider
                #default="{ errors }"
                name="Correo electrónico personal (principal)"
                rules="required|email"
              >
                <b-input-group
                  class="input-group-merge"
                >
                  <b-input-group-prepend is-text>
                    <feather-icon icon="MailIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    id="email"
                    v-model="persona.email"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Correo electrónico personal (principal)"
                    autocomplete="off"
                  />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

          </b-col>
          <!-- correo Alt -->
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group
              label="Correo electrónico institucional"
              label-for="emailAlt"
            >
              <validation-provider
                #default="{ errors }"
                name="correo electrónico institucional"
                rules="email"
              >
                <b-input-group
                  class="input-group-merge"
                >
                  <b-input-group-prepend is-text>
                    <feather-icon icon="MailIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    id="emailAlt"
                    v-model="persona.emailAlt"
                    type="email"
                    placeholder="Correo electrónico institucional"
                  />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

          </b-col>
        </b-row>
        <b-row>
          <b-col
            cols="12"
            md="12"
            lg="12"
          >
            <formularioDireccion
              ref="datosPersonalesDireccion"
              :direccionx="direccion"
            />
          </b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col>
            <b-button
              variant="primary"
              class="mb-1 mb-sm-0 mr-0 mr-sm-1"
              @click.prevent="validationForm()"
            >
              Guardar
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-overlay>
</template>

<script>
import store from '@/store'
import formularioDireccion from '@/views/components/datosDireccion.vue'
import { postData } from '@core/utils/http/general'
import { isEmptyObject, isObject } from '@core/utils/utils'
import { email, required } from '@validations'
import {
  BButton,
  BCol, BForm, BFormGroup, BFormInput,
  BFormRadioGroup,
  BFormSelect, BFormSelectOption,
  BInputGroup,
  BInputGroupPrepend,
  BOverlay,
  BRow,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    BRow,
    BCol,
    flatPickr,
    BFormRadioGroup,
    BButton,

    BFormGroup,
    BForm,
    BFormInput,
    BInputGroupPrepend,
    BInputGroup,
    BOverlay,
    BFormSelect,
    BFormSelectOption,
    ValidationProvider,
    ValidationObserver,
    formularioDireccion,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      direccion_form: { type: Object },
      // VALIDATIONS
      required,
      email,
      // EXTRA
      counter: 1,
      loader: {
        formulario: false,
      },
    }
  },
  computed: {
    persona: {
      get() {
        if (isObject(this.userData.persona[0]) && !isEmptyObject(this.userData.persona[0])) return this.userData.persona[0]
        return {}
      },
      set(newValue) { this.persona = newValue },
    },
    direccion: {
      get() {
        if (isObject(this.userData.direccion[0]) && !isEmptyObject(this.userData.direccion[0])) return this.userData.direccion[0]
        return {}
      },
      set(newValue) { this.direccion = newValue },
    },
  },
  setup() {
    const funcionarioOptions = [
      { text: 'Si', value: 'S' },
      { text: 'No', value: 'N' },
    ]

    const genderOptions = [
      { text: 'Masculino', value: 'M' },
      { text: 'Femenino', value: 'F' },
    ]

    return {
      funcionarioOptions,
      genderOptions,
    }
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          const d = this.$refs.datosPersonalesDireccion.formulario
          if (d.calle === null || d.calle === '') this.submitForm()
          else if (d.municipio.id !== null) this.submitForm()
          else {
            this.$bvToast.toast('El municipio es un dato requerido', {
              title: ' Falta completar datos',
              variant: 'danger',
              solid: true,
            })
          }
        }
      })
    },
    submitForm() {
      if (this.counter <= 10) {
        const params = new FormData()
        this.loader.formulario = true
        this.persona.id = this.userData.fk
        params.append('task', 'wsperfil')
        params.append('origin', process.env.VUE_APP_ORIGIN_API)
        params.append('token', store.state.cuenta.session.token)
        params.append('action', 1)
        params.append('datos', JSON.stringify(this.persona))
        postData(params)
          .then(response => {
            if (response.status === 200 && response.data.status === 200) {
              this.userData.nombreCompleto = `${this.persona.nombre} `
              if (this.persona.segundoNombre) this.userData.nombreCompleto += `${this.persona.segundoNombre}`
              this.userData.nombreCompleto += ` ${this.persona.apellidoPaterno}
              ${this.persona.apellidoMaterno}`
              this.loader.formulario = false
              this.submitFormDireccion()
            } else {
              this.loader.formulario = false
              this.$bvToast.toast(response.data.message, {
                title: `${response.data.status}-${response.data.status === 500 ? 'Error al realizar actualizar datos de la persona' : 'Atención'} `,
                variant: `${response.data.status === 500 ? 'danger' : 'warning'}`,
                solid: true,
              })
            }
          })
          .catch(err => {
            this.loader.formulario = false
            this.$bvToast.toast(err, {
              title: 'Error en solicitud persona',
              variant: 'danger',
              solid: true,
            })
          })
        this.counter += 1
      } else {
        this.$bvToast.toast('La página ha expirado, por favor, intente nuevamente más tarde', {
          title: 'Exceso de intentos',
          variant: 'danger',
          solid: true,
        })
      }
    },
    submitFormDireccion() {
      const params = new FormData()
      // this.loader.formulario = true
      this.direccion_form = this.$refs.datosPersonalesDireccion.formulario
      this.direccion_form.persona_id = this.userData.fk
      params.append('task', 'wsperfil')
      params.append('origin', process.env.VUE_APP_ORIGIN_API)
      params.append('token', store.state.cuenta.session.token)
      params.append('action', 11)
      params.append('data', JSON.stringify(this.direccion_form))
      postData(params)
        .then(response => {
          if (response.status === 200 && response.data.status === 200) {
            this.registroExitoso()
          } else {
            this.$bvToast.toast(response.data.message, {
              title: `${response.data.status}-${response.data.status === 500 ? 'Error al realizar actualizar dirección' : 'Atención'} `,
              variant: `${response.data.status === 500 ? 'danger' : 'warning'}`,
              solid: true,
            })
          }
          this.loader.formulario = false
        })
        .catch(err => {
          this.loader.formulario = false
          this.$bvToast.toast(err, {
            title: 'Error en solicitud direccion',
            variant: 'danger',
            solid: true,
          })
        })
    },
    registroExitoso() {
      this.$swal({
        title: '<b>Registro modificado</b>',
        icon: 'success',
        timer: 10000,
        showConfirmButton: false,
        buttonsStyling: false,
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
